/*
 * StandbyTable Messages
 *
 * This contains all the text for the StandbyTable component.
 */

import { defineMessages } from 'react-intl';

export const scope =
  'src.pages.ProjectDetailsPage.components.JobDetails.components.TransferForm.components.StandbyTable';

export default defineMessages({
  standbyUserColumnLabel: {
    id: `${scope}.standbyUserColumnLabel`,
    defaultMessage: 'Standby List',
  },
  lastLoginTimeColumnLabel: {
    id: `${scope}.lastLoginTimeColumnLabel`,
    defaultMessage: 'Last Online Time',
  },
  removeButtonTooltip: {
    id: `${scope}.removeButtonTooltip`,
    defaultMessage: 'Remove',
  },
  removeConfirmMessage: {
    id: `${scope}.removeConfirmMessage`,
    defaultMessage: 'Are you sure you want to remove this user?',
  },
});
